import React, { Fragment } from "react";
import LoyaltyTransactionsList from "./LoyaltyTransactionsList";

export default function LoyaltyDashboard() {
  return (
    <Fragment>
      <LoyaltyTransactionsList />
    </Fragment>
  );
}
